import { useQuery } from '@tanstack/react-query';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import { UserProfile } from './types';

export const toggleUser = async (
  dispatch: Dispatch,
  userId: number,
  active: boolean,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/admin/users/${userId}/toggle`,
    dispatch,
    data: { active },
  });
  return response;
};

export const assignSubordinate = async (
  dispatch: Dispatch,
  userId: number,
  subordinates: number[],
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/admin/users/${userId}/subordinate/`,
    dispatch,
    data: { subordinates },
  });
  return response;
};

export const getSubordinates = async (dispatch: Dispatch, userId: number) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/admin/users/${userId}/subordinate/`,
    dispatch,
  });
  return response;
};

export const getUserProfile = (dispatch: Dispatch, id?: number) =>
  useQuery({
    queryKey: ['user', 'profile', id],
    queryFn: async (): Promise<UserProfile | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/users/${id}/profile`,
        dispatch,
      });
      if (response) return response.data;
    },
    retry: false,
    enabled: !!id,
    staleTime: 1000 * 60 * 12,
    gcTime: 1000 * 60 * 12,
  });
